import { ReactNode } from 'react'
import {
  Box,
  Divider,
  ListItemButton,
  ListItemButtonProps,
  Typography,
  styled,
} from '@mui/material'
import { ChevronLeftIcon } from '@weblite/icons'

const StyledListItemButton = styled(ListItemButton)`
  width: 100%;
  min-height: 66px;

  margin: 0;
  background-color: transparent;
  padding: 8px 16px;
  outline: none;
  justify-content: space-between;
  text-align: inherit;
`

const StyledDivider = styled(Divider)`
  margin-right: 15px;
  &:last-child {
    display: none;
  }
`

interface Props {
  value: string | ReactNode
  label: string
  placeholder?: string
  showIcon?: boolean
  onClick: ListItemButtonProps['onClick']
}

// TODO: [refactor] rename props to more meaningful names
// FIXME: maybe list item can be a better option for lists
// FIXME: dir="auto" for now in description but it can be forced to some based on body tag
export function ProfileInfoItem({
  value,
  label,
  placeholder,
  onClick,
  showIcon,
}: Props) {
  return (
    <>
      <StyledListItemButton onClick={onClick}>
        <Box>
          <Typography
            gutterBottom
            variant="subtitle4"
            component="div"
            color="secondary700"
            sx={{ marginBottom: '4px', textAlign: 'right' }}
          >
            {label}
          </Typography>
          <Typography
            dir="auto"
            variant="body2"
            color={value ? 'neutral900' : 'semiLightGray'}
          >
            {value || placeholder}
          </Typography>
        </Box>
        {showIcon && <ChevronLeftIcon sx={{ color: 'neutral500' }} />}
      </StyledListItemButton>
      <StyledDivider />
    </>
  )
}

ProfileInfoItem.defaultProps = {
  placeholder: '',
}
